<template>
  <div>
    <el-row type="flex" align="middle" justify="space-between">
      <el-col :span="12">
        <div class="page-title">推廣碼詳情</div>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="info" @click="onProgramText">編輯推廣碼</el-button>
      </el-col>
    </el-row>
    <div class="page-box">
      <el-row class="row-list">
        <el-col :span="12"> 推廣碼 ： {{ detail.code }}</el-col>
      </el-row>
      <el-row class="row-list">
        <el-col :span="12"> 描述 ： {{ detail.description }}</el-col>
      </el-row>
      <el-row class="row-list">
        <el-col :span="12">折扣 ：{{ detail.discount }}%</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {getPromotionCodesDetail} from '@/api/order'
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detail: {
        code: null,
        description: null,
        discount: null,
      },
    };
  },
  created() {
    this.getPromotionCodesDetail();
  },
  methods: {
    onProgramText() {
      let path = `/promote/${this.id}/edit`
      this.resolveRouter(path)
    },
    getPromotionCodesDetail() {
      getPromotionCodesDetail(this.id).then((v) => {
        this.detail = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  margin: 20px 0;
  background-color: #fff;
  padding: 20px;
}
.row-list {
  margin-bottom: 10px;
}
</style>